/**
 * SVG module
 * @module SVG
 * @see module: WTM_Libs
 */
define(['wtm_libs'], (wtm) => {
    /**
     * Object containing socials reveal function & trigger
     * @type {Object}
     */
    let socials = {};
    Object.defineProperty(socials, "show", {
        set: () => {
            let targets = Array.from(document.getElementsByClassName("b_social__wrapper"));
            if (targets.length > 0) {
                targets.forEach((elem) => {
                    elem.classList.add("b_social__wrapper--visible");
                });
            }
        }
    });

    /**
     * Function to iterate icons and convert SVG
     */
    (() => {
        $('img' + wtm.widgets.svg.get__svg_selector).each(function(key) {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');
            jQuery.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add rplaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);
            }, 'xml');

            //change the object and trigger setter
            socials.show = true; 
        });
    })();
});